import { Box, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

import type { AiAskIndexData } from '../../utils/aiAskHelpers';
import {
  getSnippetFromHit,
  getTitleFromHit,
  indexLabelForName,
  stripHtml,
} from '../../utils/aiAskHelpers';

export const HitPreviewList: React.FC<{
  hits: Record<string, unknown>[];
  indexData?: AiAskIndexData;
  indexLabel?: string;
  title?: string;
  maxItems?: number;
}> = ({
  hits,
  indexData,
  indexLabel,
  title = 'Top matches',
  maxItems = 6,
}) => {
  if (!hits.length) {
    return null;
  }

  return (
    <Box mt={2}>
      {title ? (
        <Text fontSize="xs" fontWeight="500" color="gray.600" mb={2}>
          {title}
        </Text>
      ) : null}
      <VStack align="stretch" spacing={2}>
        {hits.slice(0, maxItems).map((searchHit, hitIndex) => {
          const hitIndexName = String(searchHit.__index ?? '');
          const sectionLabel = hitIndexName
            ? indexLabelForName(indexData, hitIndexName)
            : indexLabel ?? 'Result';
          const hitObjectId = String(searchHit.objectID ?? hitIndex);

          return (
            <Box key={`${hitObjectId}-${hitIndex}`} fontSize="sm">
              <Text fontSize="xs" color="blue.600" fontWeight="500">
                {sectionLabel}
              </Text>
              <Text fontWeight="600" color="gray.800">
                {getTitleFromHit(searchHit)}
              </Text>
              <Text color="gray.600" fontSize="xs" noOfLines={3}>
                {stripHtml(getSnippetFromHit(searchHit)).slice(0, 220)}
              </Text>
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
};
